import { Link, useNavigate } from "react-router-dom";
import Placeholder from "../../assets/placeholder.png";
import Check from "../../assets/check.png";
import Button from "../../componentsTemplate/Button/Button";
import { AiFillCheckSquare } from "react-icons/ai";
import { MdOutlineCheckBox } from "react-icons/md";
import { useState } from "react";

const PlanCard: React.FC<any> = ({plan, setPlanSelected = () => {}, monthly = false}) => {
  console.log(plan);
  const urlBase = process.env.REACT_APP_BACKEND_API_URL;
  const navigate = useNavigate();

  const renderCheckImg = (label = "") => {
    return (
      <div className="flex justify-between px-10 md:px-0 md:justify-center items-center h-10 bg-[#e2e1df] border-b border-gray-300">
          <div className="block md:hidden text-sm">
            {label}
          </div>
          <MdOutlineCheckBox size={30} className="text-primary-700" />
      </div>
    );
  }

  const handleAccessButton = () => {

    if(plan.is_default) {
      navigate('/');
    } else {
      setPlanSelected(plan);
    }
  }

  const getDatebyDays = (days: number) => {
    // se for igual a 365 ou 366 dias, retorna 1 ano
    if(days === 365 || days === 366) {
      return '1 ano';
    } else {
      return days + ' dias';
    }
  }

  const getFormatedPrice = (price: number) => {

    const formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });

    if (!price) return 'R$ -,--';

    return formatter.format(price);
  }

  return (

      <div className="rounded-t-3xl shadow rounded-b-3xl">

          <div className="flex rounded-t-3xl bg-primary-700 justify-center items-center text-center h-24 uppercase text-white font-bold text-2xl">
            {plan.name ?? "-"} 
          </div>
          <div>
            {
            plan.is_default ? (
              <div className="bg-[#262626] h-[120px]">
                <div className="flex items-end justify-center text-2xl font-bold text-primary-700 text-center h-[80px]">
                  INSCRIÇÃO 
                  <br />
                  GRATUÍTA
                </div>
                <div className="flex justify-center text-[10px] text-white h-[40px]">
                  * somente para integrantes Radar
                </div>
              </div>
            ) : (
              <div className="bg-[#262626] h-[120px] px-2">
                <div className="text-white text-[10px] h-[40px] flex items-end justify-center border-b border-primary-700">
                  Assinatura de {getDatebyDays(plan.duration_in_days)}
                </div>
                <div className="text-primary-700 h-[40px] flex items-end justify-center border-b border-primary-700 text-3xl font-bold">
                  {/* {getFormatedPrice(plan.price)} */}

                  {
                    monthly ? (
                      <>
                        <div className="text-lg mr-1">
                          {plan.installment_info?.installments + 'x '}
                        </div>
                        {getFormatedPrice(plan.installment_info?.installment_amount)}
                      </>

                    ) : (
                      <>
                        {getFormatedPrice(plan.price)}
                      </>
                    )
                  }
                  
                  {/* if (monthly) {
      return plan.installment_info?.installments + 'x ~' + formatter.format(plan.installment_info?.installment_amount);
    } else {
      return formatter.format(price);
    } */}

                </div>
                <div className="text-white text-[10px] h-[40px] flex justify-center border-b border-primary-700">
                  veja as opções de parcelamento
                </div>
              </div>
            )}
          </div>

          <div className="bg-[#e2e1df] px-2 rounded-b-3xl">
            <div className="h-10 flex justify-center items-center border-b border-gray-300 text-sm">
              {
                plan.allows_all_cities ? (
                  'Todas as Cidades'
                ) : (
                  'Sua cidade' + (plan.number_of_cities ? ( ' + ' + plan.number_of_cities) : '')
                )
              }
            </div>

            {
              plan.allows_events ? 
                renderCheckImg('Eventos') : 
                <div className="h-10 border-b border-gray-300"></div>
            }

            {
              plan.allows_classifieds ? 
                renderCheckImg('Classificados') : 
                <div className="h-10 border-b border-gray-300"></div>
            }

            {
              plan.allows_social_partnerships ? 
                renderCheckImg('Radar Solidário') : 
                <div className="h-10 border-b border-gray-300"></div>
            }

            { renderCheckImg('Descontos Exclusivos') }

            {
              plan.allows_special_categories ? 
                renderCheckImg('Radar Viagens') : 
                <div className="h-10 border-b border-gray-300"></div>
            }

            {
              plan.allows_contacts ? 
                renderCheckImg('Business Networking') : 
                <div className="h-10 border-b border-gray-300"></div>
            }

            <div className="h-24 py-2 w-full flex items-end justify-center">
              <Button
                pattern="primary"
                onClick={() => handleAccessButton()}
                className="planoBackgroundCor w-full"
              >
                {plan.is_default ? 'ACESSE AQUI' : 'ASSINAR AGORA'}
              </Button>
            </div>

          </div>
      </div>

    // <div className="overflow-hidden ml-4 modoMobilePlano rounded-xl w-60 md:w-80 2xl:w-96 shadow-xl mb-0 md:mb-10">
    //   <div className="flex flex-col overflow-hidden items-center justify-between py-2 px-2 sm:px-4 md:px-6 bg-[#695339] dark:bg-neutral-900/95 planoBackgroundCor">
    //     <br /> 
    //     <span style={{ display: 'flex', justifyContent: 'center' }} className="text-start line-clamp-1 sm:line-clamp-none w-full [font-family:'Poppins-SemiBold',Helvetica] font-semibold text-white text-base lg:text-xl uppercase">
    //       {plan.name ?? "-"}
    //     </span><br />
    //   </div>
    //   <div
    //     className="w-full h-40 bg-[#262626]"
    //     style={{
    //       display: 'flex',
    //       flexDirection: 'column', // Alinha os itens verticalmente
    //       alignItems: 'center', // Centraliza os itens horizontalmente
    //       justifyContent: 'center', // Centraliza os itens verticalmente
    //       textAlign: 'center', // Alinha o texto no centro
    //     }}
    //   >
    //     {
    //       plan.is_default ? (
    //         <>
    //           <div
    //             className="[font-family:'Poppins-Regular',Helvetica]"
    //             style={{ color: '#a17e58', fontSize: '30px' }}
    //           >
    //             GRATUITO
    //           </div>
    //           <div style={{ color: '#fff', fontSize: '12px' }}>
    //             * somente para integrantes Radar
    //           </div>
    //         </>
    //       ) : (
    //         <>
    //           <div style={{ color: '#fff', fontSize: '12px' }}>
    //             {getDatebyDays(plan.duration_in_days)}
    //           </div>
    //           <div className="[font-family:'Poppins-Regular',Helvetica]">
    //             <div style={{ display: 'flex' }}>
    //               {/* <div style={{ color: '#a17e58', fontSize: '30px' }}>
    //                 12X &nbsp;
    //               </div>  */}
    //               {/* <div style={{ color: 'white', fontSize: '10px', top: '-8px', position: 'relative' }}>
    //                 R$
    //               </div>  */}
    //               <div style={{ color: '#a17e58', fontSize: '30px' }}> 
    //                 {getFormatedPrice(plan.price)}
    //               </div>
    //             </div>
    //           </div>
    //           <div className="px-1" style={{ color: '#fff', fontSize: '12px' }}>
    //             veja as opções de parcelamento
    //           </div>
    //         </>
    //       )
    //     }
    //   </div>

    //   <div className="w-full h-10  bg-[#e2e1df]" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', borderBottom: '1px solid black' }}>
    //     <div className="[font-family:'Poppins-Regular',Helvetica]">

    //       {
    //         plan.allows_all_cities ? (
    //           'Todas as Cidades'
    //         ) : (
    //           'Sua cidade' + (plan.number_of_cities ? ( ' + ' + plan.number_of_cities) : '')
    //         )
    //       }
          
    //     </div>
    //   </div>

    //   {
    //     plan.allows_events ? 
    //       renderCheckImg('Eventos') : 
    //       <div className="w-full h-10  bg-[#e2e1df]" style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid black' }}></div>
    //   }

    //   {
    //     plan.allows_classifieds ? 
    //       renderCheckImg('Classificados') : 
    //       <div className="w-full h-10  bg-[#e2e1df]" style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid black' }}></div>
    //   }

    //   {
    //     plan.allows_social_partnerships ? 
    //       renderCheckImg('Radar Solidário') : 
    //       <div className="w-full h-10  bg-[#e2e1df]" style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid black' }}></div>
    //   }

    //   {/* Descontos exclusivos - Todos tem */}
    //   { renderCheckImg('Descontos Exclusivos') }

    //   {
    //     plan.allows_special_categories ? 
    //       renderCheckImg('Radar Viagens') : 
    //       <div className="w-full h-10  bg-[#e2e1df]" style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid black' }}></div>
    //   }

    //   {
    //     plan.allows_contacts ? 
    //       renderCheckImg('Business Networking') : 
    //       <div className="w-full h-10  bg-[#e2e1df]" style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid black' }}></div>
    //   }

    //   <div className="w-full h-40 h-25 pb-3 bg-[#e2e1df]" style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
    //     <Button
    //       pattern="primary"
    //       onClick={() => handleAccessButton()}
    //       className="planoBackgroundCor"
    //     >
    //       {plan.is_default ? 'ACESSE AQUI' : 'ASSINAR AGORA'}
    //     </Button>
    //   </div>

    // </div>
  );
};

export default PlanCard;
